// feed/client.js
// Loads/updates content in feed components.
import $ from 'jquery';
import _ from 'lodash';
import radio from 'radio';
import { RERENDER_ALL, FEED_LOADED, RESIZE } from 'shared/enums/events';
import 'lib-unicorn/third-party/js/owl-carousel';
import template from './component.hbs';

const refreshCarousel = function refreshCarousel($feed) {
  if (!$feed.length || !$feed.hasClass('header-recirc') || !$feed.children().length) {
    return false;
  }
  const hasCarousel = $feed.hasClass('owl-loaded');

  if (window.matchMedia('(min-width: 1024px)').matches) {
    if (hasCarousel) {
      $feed
        .trigger('destroy.owl.carousel')
        .removeClass('owl-theme owl-center owl-loaded');
    }
  } else if (!hasCarousel) {
    $feed.owlCarousel({ autoWidth: true });
  }

  return true;
};

const resizeFeed = function resizeFeed() {
  const $feed = $('.header-recirc');
  refreshCarousel($feed);
};

const renderTemplate = function renderTemplate(data, $context, partial, elementData) {
  const templateData = { content: data };

  $.extend(templateData, $context.data());

  if (partial != null) {
    templateData.partial = partial;
  }

  if (templateData.native_ad && templateData.content.length) {
    templateData.content[0].native_ad = templateData.native_ad;
  }

  if (templateData.nativekey) {
    templateData.content[0].nativekey = templateData.nativekey;
  }

  const $newContent = $($(template(templateData)).html());

  if ($context.attr('data-fill-method') === 'append') {
    $context.append($newContent);
    $newContent.remove('h3');
  } else {
    $context.html($newContent);
  }

  Object.keys(elementData).map(key => $context.data(key, elementData[key]));

  radio(RERENDER_ALL).broadcast();
  radio(FEED_LOADED).broadcast($context.data());
  radio(RESIZE).subscribe(resizeFeed);

  refreshCarousel($context);
};

const render = function render($context) {
  const endpoint = $context.data('endpoint');
  if ((endpoint == null) || (endpoint === 'null')) { return false; }

  const json = $context.data('request-data') || '{}';
  const data = JSON.parse(decodeURIComponent(json));
  const partial = $context.data('partial');
  const elementData = $context.data();

  if (elementData.native_ad) {
    elementData.native_ad = JSON.parse(decodeURIComponent(elementData.native_ad));
  }

  $.get(endpoint, data, (response) => {
    // If the response has fewer than the requested elements in the feed, make
    // the request again with 'term' unset, which will fill in the rest of the
    // feed with recent content.
    if (_.get(response, 'data.length', 0) < data.count) {
      const fallbackData = data;
      delete fallbackData.term;
      fallbackData.count = data.count - response.data.length;
      $.get(endpoint, fallbackData, (fallbackResponse) => {
        renderTemplate(fallbackResponse != null
          ? response.data.concat(fallbackResponse.data)
          : undefined, $context, partial, elementData);
      });
    } else {
      renderTemplate(response != null
        ? response.data
        : undefined, $context, partial, elementData);
    }
  });

  return true;
};

export default function feedComponent() {
  $('.component.feed').data('component-loaded', true);
  $('.component.feed[data-endpoint]').each(function iterateComponents() {
    const $context = $(this);
    render($context);

    if ($context.data('radio-subscription')) {
      const subscription = $context.data('radio-subscription');
      radio(subscription).subscribe((assignedData) => {
        let data = assignedData;
        if (data == null) { data = { endpoint: null }; }
        if (data.endpoint != null) { $context.data('endpoint', data.endpoint); }
        render($context);
      });
    }
  });
}



// WEBPACK FOOTER //
// ./~/unicorn/shared/components/feed/client.js